import React, { useContext, useState, useEffect } from "react";
import "./style.scss";
import { Header } from "src/component";
import ApiContext from "src/provider/API/call-service";
import {
  AppText,
  Button,
  CustomContainer,
  FlexColumn,
  FlexRow,
  Form,
  FormGroup,
  FormGroupsWrapper,
  FormGroupWithIcon,
  RoundImageContainer,
  ScreenContainer,
} from "src/style";
import utility from "src/utils/utility";
import UserContext from "src/provider/state-manager/userProvider";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";
import Pic from "src/assets/img/32.png";
import { FaUser } from "react-icons/fa";
import { HiMail } from "react-icons/hi";
import {
  BsFillPersonFill,
  BsHouseDoorFill,
  BsGenderFemale,
  BsFillTelephoneFill,
} from "react-icons/bs";
import helpers from "src/utils/helpers";
import VisibilityContext from "src/provider/state-manager/visibilityProvider";
import { Select } from "src/component";
import { getClassList } from "src/utils/helpers";
const AddUser: React.FC = () => {
  const { user } = useContext(UserContext);
  const { API } = useContext(ApiContext);
  const { info, setSubmitUser } = useContext(AppInfoContext);
  const [openModal, setOpenModal] = useState(false);
  const [clear, setClear] = useState(false);
  const [memberDetails, setMemberDetails] = useState({
    firstName: "",
    surname: "",
    email: "",
    memberType: "",
    phoneNumber: "",
    address: "",
    memberClass: "",
    gender: "",
  });
  const { notifier, visibility, setModal } = useContext(VisibilityContext);

  const handleSelectField = (e: any) => {
    setMemberDetails({ ...memberDetails, [e.target.name]: e.target.value });
  };
  const handleCreate = (
    e: React.FormEvent<HTMLButtonElement | HTMLFormElement>
  ) => {
    e.preventDefault();
    const validation = helpers.inputValidator(memberDetails);
    if (!validation.isValidated) {
      return notifier.show(validation.message, "Validation Response");
    }
    setModal({ key: "showAddUserModal", value: !visibility.showAddUserModal });
  };
  const closeModal = () => {
    setOpenModal(false);
  };
  const handleSubmit = async () => {
    //e.preventDefault()
    // const validation = helpers.inputValidator(memberDetails);
     closeModal()
    await API.addMember(memberDetails);
    setMemberDetails({
      ...memberDetails,
      firstName: "",
      surname: "",
      address: "",
      phoneNumber: "",
      memberClass: "",
      memberType: "",
      gender: "",
      email: "",
    });
    setClear(true);
  };

  const handleClassSelect = (key: string, value: string) => {
    setMemberDetails({ ...memberDetails, [key]: value });
  };
  const handleMemberType = (key: string, value: string) => {
    setMemberDetails({ ...memberDetails, [key]: value });
  };
  const handleGenderTyoe = (key: string, value: string) => {
    setMemberDetails({ ...memberDetails, [key]: value });
  };

  useEffect(() => {
    if (info.submitUser) handleSubmit();
    setSubmitUser(false);
  }, [info.submitUser]);

  return (
    <ScreenContainer padding="3" className="screenContainer">
      <Header user={user} className="add-user-header">
        <AppText color="#fff" textSize="3.2" fontWeight="500">
          Add New User
        </AppText>
      </Header>
      <CustomContainer
        bgColor="#FFF5E5"
        topPadding="3"
        rightPadding="6"
        bottomPadding="0"
        leftPadding="6"
        radius="1"
        className="container"
      >
        <FlexRow gap="2">
          <RoundImageContainer size="8">
            <img src={Pic} alt="" width="100%" height="100%" />
          </RoundImageContainer>
          <FlexColumn alignItems="flex-start">
            <AppText color="#712126" textSize="2">
              Add New User
            </AppText>
            <AppText color="#374957" textSize="1.5">
              ID: {user?.profile?.regId}
            </AppText>
          </FlexColumn>
        </FlexRow>
        <form className="form-container">
          <FormGroupsWrapper gap="10" className="formGroup--wrapper">
            <FormGroupWithIcon
              bgColor="#fff"
              inputColor="#374957"
              borderColor="#8A8A8A"
              width="40"
              className="formGroup"
            >
              <AppText color="#712126" fontWeight="500" bottomMargin=".9">
                First Name
              </AppText>
              <CustomContainer>
                <BsFillPersonFill className="form__input--icon" size={18} />
                <input
                  type="text"
                  className="form__input"
                  placeholder="Enter First Name"
                  name="firstName"
                  value={memberDetails.firstName}
                  onChange={handleSelectField}
                />
              </CustomContainer>
            </FormGroupWithIcon>
            <FormGroupWithIcon
              bgColor="#fff"
              inputColor="#374957"
              borderColor="#8A8A8A"
              width="40"
              className="formGroup"
            >
              <AppText color="#712126" fontWeight="500" bottomMargin=".9">
                Last Name
              </AppText>
              <CustomContainer>
                <BsFillPersonFill className="form__input--icon" size={18} />
                <input
                  type="text"
                  className="form__input"
                  placeholder="Enter Last Name"
                  name="surname"
                  value={memberDetails.surname}
                  onChange={handleSelectField}
                />
              </CustomContainer>
            </FormGroupWithIcon>
          </FormGroupsWrapper>

          <FormGroupsWrapper gap="10" className="formGroup--wrapper">
            <FormGroupWithIcon
              bgColor="#fff"
              inputColor="#374957"
              borderColor="#8A8A8A"
              width="40"
              className="formGroup"
            >
              <AppText color="#712126" fontWeight="500" bottomMargin=".9">
                Email
              </AppText>
              <CustomContainer>
                <HiMail className="form__input--icon" size={18} />
                <input
                  type="email"
                  className="form__input"
                  placeholder="Enter Email"
                  name="email"
                  value={memberDetails.email}
                  onChange={handleSelectField}
                />
              </CustomContainer>
            </FormGroupWithIcon>
            <FormGroupWithIcon
              bgColor="#fff"
              inputColor="#374957"
              borderColor="#8A8A8A"
              width="40"
              className="formGroup"
            >
              <AppText color="#712126" fontWeight="500" bottomMargin=".9">
                Phone Number
              </AppText>
              <CustomContainer>
                <BsFillTelephoneFill className="form__input--icon" size={18} />
                <input
                  type="text"
                  className="form__input"
                  placeholder="Enter Phone number"
                  name="phoneNumber"
                  value={memberDetails.phoneNumber}
                  onChange={handleSelectField}
                />
              </CustomContainer>
            </FormGroupWithIcon>
          </FormGroupsWrapper>

          <FormGroupsWrapper gap="10" className="formGroup--wrapper">
            <FormGroupWithIcon
              bgColor="#fff"
              inputColor="#374957"
              borderColor="#8A8A8A"
              width="40"
              className="formGroup"
            >
              <AppText color="#712126" fontWeight="500" bottomMargin=".9">
                Address
              </AppText>
              <CustomContainer>
                <BsHouseDoorFill className="form__input--icon" size={18} />
                <input
                  type="text"
                  className="form__input"
                  placeholder="Enter Address"
                  name="address"
                  value={memberDetails.address}
                  onChange={handleSelectField}
                />
              </CustomContainer>
            </FormGroupWithIcon>
            <FormGroupWithIcon
              bgColor="#fff"
              inputColor="#374957"
              borderColor="#8A8A8A"
              width="40"
              className="formGroup"
            >
              <Select
                placeholder="Select User Class"
                label="Class"
                list={getClassList(info)}
                handleSelect={handleClassSelect}
                labelColor="#712126"
                labelSize="1.5"
                className="select-dropdown"
                height="20rem"
                name="memberClass"
                clearSelect={clear ? true : false}
              />
            </FormGroupWithIcon>
          </FormGroupsWrapper>
          <FormGroupsWrapper gap="10" className="formGroup--wrapper">
            <FormGroupWithIcon
              bgColor="#fff"
              inputColor="#374957"
              borderColor="#8A8A8A"
              width="40"
              className="formGroup"
            >
              <Select
                label="User Type"
                labelColor="#712126"
                placeholder="Select User Type"
                list={["Teacher", "Student"]}
                handleSelect={handleMemberType}
                Icon={<FaUser color="#B8B8B8" />}
                labelSize="1.5"
                className="select-dropdown"
                name="memberType"
                clearSelect={clear ? true : false}
              />
            </FormGroupWithIcon>
            <FormGroupWithIcon
              bgColor="#fff"
              inputColor="#374957"
              borderColor="#8A8A8A"
              width="40"
              className="formGroup"
            >
              <Select
                label="Gender"
                labelColor="#712126"
                placeholder="Select Gender"
                list={["Male", "Female"]}
                handleSelect={handleGenderTyoe}
                Icon={<BsGenderFemale color="#B8B8B8" />}
                labelSize="1.5"
                className="select-dropdown"
                name="gender"
                clearSelect={clear ? true : false}
              />
            </FormGroupWithIcon>
          </FormGroupsWrapper>
          <FormGroupsWrapper>
            <FormGroup topMargin="2" width="40" className="formGroup">
              <Button
                bgColor="#A77B37"
                hoverBgColor="#712126"
                hoverColor="#fff"
                style={{ width: "100%" }}
                onClick={handleCreate}
                fontWeight="500"
              >
                Create User
              </Button>
            </FormGroup>
          </FormGroupsWrapper>
        </form>
      </CustomContainer>
    </ScreenContainer>
  );
};
export default utility.routeData("add-user", "Add User", <AddUser />);
